import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-738739f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row w-full justify-end mb-3" }
const _hoisted_2 = { class: "bg-white mx-auto mb-8" }
const _hoisted_3 = { class: "text-white mb-6 p-3 rounded-lg bg-[#0060EE] w-full font-semibold" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "bg-[#B2CCFF] text-white text-xs font-semibold px-5 py-1 rounded-full me-4" }
const _hoisted_10 = { class: "flex justify-between items-center w-full mb-6" }
const _hoisted_11 = {
  for: "class-filter",
  class: "block text-sm font-medium text-[#344054] mb-1"
}
const _hoisted_12 = { value: "" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "min-w-full w-full" }
const _hoisted_15 = { class: "columns" }
const _hoisted_16 = { class: "border-y border-y-[#EAECF0] border-l border-l-[#EAECF0] py-3 text-[#475467] font-medium text-xs text-start pl-6" }
const _hoisted_17 = ["checked"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "border-y border-y-[#EAECF0] py-3 text-[#475467] font-medium text-xs text-start" }
const _hoisted_22 = { class: "border-y border-y-[#EAECF0] border-r border-r-[#EAECF0] py-3 text-[#475467] font-medium text-xs text-start pr-6" }
const _hoisted_23 = { class: "border-y border-y-[#EAECF0] border-r border-r-[#EAECF0] py-3 text-[#475467] font-medium text-xs text-start pr-6 hidden" }
const _hoisted_24 = { class: "text-[#101828] text-sm font-medium py-6 border-b border-b-[#EAECF0] pl-6 border-l border-l-[#EAECF0]" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "text-[#475467] text-sm py-6 border-b border-b-[#EAECF0]" }
const _hoisted_27 = { class: "text-[#475467] text-sm py-6 border-b border-b-[#EAECF0]" }
const _hoisted_28 = { class: "text-[#475467] text-sm py-6 border-b border-b-[#EAECF0]" }
const _hoisted_29 = { class: "text-[#475467] text-sm py-6 border-b border-b-[#EAECF0]" }
const _hoisted_30 = { class: "flex justify-start items-center gap-2" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "text-[#475467] text-sm py-6 border-b border-b-[#EAECF0] pr-6 border-r border-r-[#EAECF0]" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-[#475467] text-sm py-6 border-b border-b-[#EAECF0] pr-6 border-r border-r-[#EAECF0] hidden" }, /*#__PURE__*/_toDisplayString("******"), -1))
const _hoisted_34 = { class: "pagination w-full text-center my-8 flex items-center space-x-1 justify-center" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex item-center justify-between mt-6" }
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_39 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_40 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mx-auto",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_16213_19367)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M57.1433 2.28572H6.85756C5.64514 2.28572 4.48238 2.76735 3.62507 3.62466C2.76776 4.48197 2.28613 5.64473 2.28613 6.85715V45.7143C2.28613 46.9267 2.76776 48.0895 3.62507 48.9468C4.48238 49.8041 5.64514 50.2857 6.85756 50.2857H16.0004V61.7143L30.2633 50.2857H57.1433C58.3557 50.2857 59.5185 49.8041 60.3758 48.9468C61.2331 48.0895 61.7147 46.9267 61.7147 45.7143V6.85715C61.7147 5.64473 61.2331 4.48197 60.3758 3.62466C59.5185 2.76735 58.3557 2.28572 57.1433 2.28572Z",
      stroke: "#4B5563",
      "stroke-width": "4.57143",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M25.1426 20.5714C25.1426 19.2152 25.5447 17.8895 26.2982 16.7618C27.0517 15.6341 28.1226 14.7553 29.3756 14.2363C30.6286 13.7173 32.0073 13.5815 33.3375 13.846C34.6676 14.1106 35.8895 14.7637 36.8485 15.7227C37.8074 16.6817 38.4605 17.9035 38.7251 19.2337C38.9897 20.5638 38.8539 21.9426 38.3349 23.1955C37.8159 24.4485 36.937 25.5195 35.8093 26.2729C34.6817 27.0264 33.3559 27.4286 31.9997 27.4286V29.7143",
      stroke: "#4B5563",
      "stroke-width": "4.57143",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M31.9999 36.5714C31.3218 36.5714 30.6589 36.7725 30.0951 37.1492C29.5312 37.526 29.0918 38.0615 28.8323 38.6879C28.5728 39.3144 28.5049 40.0038 28.6372 40.6689C28.7695 41.334 29.096 41.9449 29.5755 42.4244C30.055 42.9039 30.6659 43.2304 31.331 43.3627C31.9961 43.495 32.6854 43.4271 33.3119 43.1676C33.9384 42.9081 34.4739 42.4686 34.8506 41.9048C35.2274 41.341 35.4284 40.6781 35.4284 40C35.4166 39.0944 35.0516 38.2292 34.4111 37.5887C33.7707 36.9483 32.9055 36.5833 31.9999 36.5714Z",
      fill: "#4B5563"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_16213_19367" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "64",
        height: "64",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_42 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#475467]" }, " If not, we will autogenerate an email address for them to login with the following structure: "),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-sm text-[#475467]" }, " Iname.surname@schoolname.co.za ")
], -1))
const _hoisted_44 = { class: "mt-5 sm:mt-6 flex items-center justify-center gap-x-4" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_46 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_47 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_48 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_50 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_51 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_52 = { class: "mt-6 text-center" }
const _hoisted_53 = { class: "flex justify-between mb-6" }
const _hoisted_54 = { class: "flex items-center" }
const _hoisted_55 = { class: "space-y-5" }
const _hoisted_56 = { class: "mb-4 flex items-center justify-between text-sm" }
const _hoisted_57 = { class: "font-semibold" }
const _hoisted_58 = { class: "w-full bg-[#EAECF0] rounded-full h-2 dark:bg-gray-700" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-4" }, null, -1))
const _hoisted_60 = { class: "w-full max-h-[30rem] overflow-y-scroll" }
const _hoisted_61 = { class: "table-auto w-full divide-y divide-gray-300" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "rounded-lg" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 text-start text-xs font-semibold text-gray-600" }),
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 py-3.5 text-start text-xs font-semibold text-gray-600" }, " Email "),
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 py-3.5 text-start text-xs font-semibold text-gray-600" }, " First name "),
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 py-3.5 text-start text-xs font-semibold text-gray-600" }, " Last name "),
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 py-3.5 text-start text-xs font-semibold text-gray-600" }, " Student number "),
    /*#__PURE__*/_createElementVNode("th", { class: "sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-80 text-start text-xs font-semibold text-gray-600" }, " Password ")
  ])
], -1))
const _hoisted_63 = { class: "divide-y divide-gray-200" }
const _hoisted_64 = { class: "text-gray-500 text-sm font-medium text-start" }
const _hoisted_65 = { class: "py-1 pr-4 text-gray-500 text-sm font-medium text-start" }
const _hoisted_66 = { class: "text-gray-500 text-sm font-medium text-start" }
const _hoisted_67 = { class: "text-gray-500 text-sm font-medium text-start" }
const _hoisted_68 = { class: "text-gray-500 text-sm font-medium text-start" }
const _hoisted_69 = { class: "text-gray-500 text-sm font-medium text-start" }
const _hoisted_70 = { class: "mt-5 sm:mt-6 flex items-center justify-end gap-x-4" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_72 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_73 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_74 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_75 = { class: "relative" }
const _hoisted_76 = {
  key: 0,
  class: "absolute bottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "78",
  height: "77",
  viewBox: "0 0 78 77",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "0.9375",
    width: "76.125",
    height: "76.125",
    rx: "38.0625",
    fill: "#53DDC9",
    "fill-opacity": "0.24"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M59.9167 25.2309H33.375C31.1292 25.2309 29.2917 27.0684 29.2917 29.3142V47.6892C29.2917 48.7722 29.7219 49.8108 30.4876 50.5766C31.2534 51.3424 32.292 51.7726 33.375 51.7726H59.9167C62.1829 51.7726 64 49.9555 64 47.6892V29.3142C64 28.2313 63.5698 27.1926 62.804 26.4269C62.0382 25.6611 60.9996 25.2309 59.9167 25.2309ZM59.9167 47.6892H33.375V32.7238L46.6458 39.5226L59.9167 32.7238V47.6892ZM46.6458 36.0721L33.375 29.3142H59.9167L46.6458 36.0721ZM25.2083 47.6892C25.2083 48.0363 25.2696 48.363 25.3104 48.7101H17.0417C15.9147 48.7101 15 47.7913 15 46.6684C15 45.5455 15.9147 44.6267 17.0417 44.6267H25.2083V47.6892ZM21.125 28.2934H25.3104C25.2696 28.6405 25.2083 28.9671 25.2083 29.3142V32.3767H21.125C20.0021 32.3767 19.0833 31.458 19.0833 30.3351C19.0833 29.2121 20.0021 28.2934 21.125 28.2934ZM17.0417 38.5017C17.0417 37.3788 17.9604 36.4601 19.0833 36.4601H25.2083V40.5434H19.0833C17.9604 40.5434 17.0417 39.6246 17.0417 38.5017Z",
    fill: "#53DDC9"
  })
], -1))
const _hoisted_78 = { class: "mt-6 text-center" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500 mb-8" }, " Email with further steps will be sent to school admin and teacher. "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-[#6A737F] mb-8" }, " Upload will be processed, do you want to select any more existing students? ")
], -1))
const _hoisted_80 = { class: "mt-6 flex justify-around items-center flex-col" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "text-[#8777FF] rounded-full border border-[#8777FF] px-8 py-2 text-base mt-3 flex flex-row justify-evenly items-center flex-wrap"
}, " Class complete ", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_83 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_84 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "60",
    height: "60",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M23.4896 15.8866C21.3327 15.9696 19.3828 16.7394 18.3403 17.7831C18.2252 17.8982 18.0885 17.9895 17.938 18.0517C17.7876 18.114 17.6263 18.146 17.4635 18.146C17.3007 18.1459 17.1395 18.1138 16.9891 18.0514C16.8387 17.989 16.702 17.8977 16.5869 17.7825C16.4719 17.6673 16.3806 17.5306 16.3183 17.3802C16.2561 17.2297 16.2241 17.0685 16.2241 16.9057C16.2242 16.7429 16.2563 16.5816 16.3187 16.4312C16.381 16.2808 16.4724 16.1442 16.5876 16.0291C18.1953 14.4214 20.8133 13.509 23.3929 13.4086C25.9898 13.3082 28.8247 14.0185 30.8105 16.0043C31.043 16.2369 31.1735 16.5523 31.1734 16.8811C31.1733 17.21 31.0425 17.5253 30.8099 17.7577C30.5773 17.9901 30.2619 18.1207 29.9331 18.1205C29.6043 18.1204 29.289 17.9897 29.0565 17.7571C27.7054 16.4047 25.6303 15.8023 23.4896 15.8853V15.8866Z",
      fill: "#4B5563"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M36.1186 33.9448C38.5765 31.0402 39.9225 27.357 39.9167 23.5521C39.9167 14.6519 32.7023 7.4375 23.8021 7.4375C14.9019 7.4375 7.6875 14.6519 7.6875 23.5521C7.6875 32.4523 14.9019 39.6667 23.8021 39.6667C27.7626 39.6667 31.3883 38.2387 34.1948 35.8686L33.7188 38.6056L43.033 47.9198L48.1698 42.783L38.8556 33.4688L36.1186 33.9448ZM23.8021 35.9479C30.6483 35.9479 36.1979 30.3983 36.1979 23.5521C36.1979 16.7059 30.6483 11.1562 23.8021 11.1562C16.9559 11.1562 11.4062 16.7059 11.4062 23.5521C11.4062 30.3983 16.9559 35.9479 23.8021 35.9479Z",
      fill: "#4B5563"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M44.7854 49.6726L49.9222 44.5358L51.6031 46.2166C52.5489 47.1624 52.5489 48.6958 51.6031 49.6404L49.89 51.3535C48.9442 52.2993 47.4108 52.2993 46.4663 51.3535L44.7854 49.6726Z",
      fill: "#4B5563"
    })
  ])
], -1))
const _hoisted_86 = { class: "mt-6 text-center" }
const _hoisted_87 = { class: "mt-4 text-center" }
const _hoisted_88 = { class: "text-sm text-[#475467]" }
const _hoisted_89 = { class: "text-[#475467]" }
const _hoisted_90 = { class: "mt-6 flex justify-around items-center" }

import { FormKitNode } from "@formkit/core";
import { useLearnerStore } from "@/stores/learnerStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useLicenseStore } from "@/stores/licenseStore";
import { useNoticeStore } from "@/stores/noticeStore";
import { useFilterStore } from "@/stores/filterStore";
import { ref, watch, computed, onBeforeMount } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { useRolloverStore } from "@/stores/rolloverStore";
import { Rollover } from "@/interfaces/rollover.interface";
import { find, union } from "lodash";
import {
  UserIcon,
  TrashIcon,
  VideoCameraIcon
} from "@heroicons/vue/24/outline";
import FileUploadWidgetComponent from "../components/FileUploadWidgetComponent.vue";
import TutorialModalComponent from "../components/TutorialModalComponent.vue";

const learnersPerPage = 8;
const maxVisiblePages = 6;

export default /*#__PURE__*/_defineComponent({
  __name: 'AddStudentToClassView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const shouldGenerateEmail = ref(false);
const showFileUploadModal = ref(false);
const showGenerateEmailModal = ref(false);
const showUploadedLearnersModal = ref(false);
const showLearnersBulkUploadProgressModal = ref(false);
const bulkUploadLoading = ref(false);
const confirmAssignLearnersModal = ref(false);
const showModal = ref(false);
const gradeLevel = ref<number>(0);
const currentClassGroup = ref<any>(null);
// previous classes filter
const selectedClassFilter = ref("");
const searchQuery = ref("");
const currentPage = ref(1);
const selectedLearners = ref<string[]>([]);
const uploadedLearners = ref<any>([]);
const sortKey = ref<string | null>(null);
const sortOrder = ref<'asc' | 'desc'>('asc');

// Data Sources
const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();
const noticeStore = useNoticeStore();
const filterStore = useFilterStore();
const rolloverStore = useRolloverStore();
const licenseStore = useLicenseStore();

onBeforeMount(async () => {
  await noticeStore.fetchNotices(filterStore.selectedFilters.school as string);
  await licenseStore.fetchLicenses(
    filterStore.selectedFilters.school as string
  );

  if (licenseStore.license) {
    const payload = {
      school: filterStore.selectedFilters.school,
      license: licenseStore.license._id,
      status: "pending",
    };

    await licenseStore.fetchLicenseRequests(payload);
  }
});

const learners = computed(() => {
  return learnerStore.getSchoolLearners.filter((learner) => {
    return (
      learner.status === "active" &&
      learner.grade === gradeLevel.value
    );
  });
});

const licenseProgress = computed(
  () => (product: any) =>
    Math.round((product.seatsUsed / product.maxSeats) * 100)
);

const fetchPreviousClasses = async () => {
  const currentSchool = schoolStore.getCurrentSchool;
  if (currentSchool) {
    // await rolloverStore.fetchSchoolRollover(currentSchool._id);
  }

  return;
};

// Generate unique previous classes for the dropdown
const uniquePreviousClasses = computed(() => {
  // Ensure we're mapping over all learners with previous classes
  const allClasses = learnersWithPreviousClasses.value.flatMap((learner) =>
    learner.previousClasses.map((classDetails: any) => classDetails.name)
  );
  return [...new Set(allClasses)]; // Use Set to deduplicate
});

const classList = computed(() =>
  schoolStore?.currentSchoolStructure?.classGroups.map((classGroup) => ({
    name: classGroup.name,
    _id: classGroup._id,
    subject: classGroup.subject
  }))
);

// Create a lookup map for class IDs to names
const classMap = computed(() => {
  return (classList.value ?? []).reduce((map: Record<string, string>, classGroup) => {
    map[classGroup._id] = classGroup.name;
    return map;
  }, {} as Record<string, string>);
});

const learnersWithPreviousClasses = computed(() => {
  // Map previous classes for each learner
  const previousClassesMap = rolloverStore?.getRollover?.learnerPreviousClasses.reduce(
    (acc: Record<string, any>, curr: any) => {
      acc[curr.learner] = curr.previousClasses;
      return acc;
    },
    {} as Record<string, any>
  );

  const schoolClasses = filterStore.selectedSchool.classes;

  // Combine learner data with their previous classes' details
  return learners.value
    .map((learner) => ({
      ...learner,
      previousClasses: (previousClassesMap?.[learner._id] || []).map(
        (classDetails: any) => ({
          id: classDetails,
          name: classMap.value[classDetails._id] || "Unknown Class",
          subjectName: classDetails?.subject?.name || "Unknown Subject",
        })
      ),
    }))
    .filter((learner) => {
      // Check if the learner is already assigned to the current class
      const isAssignedToCurrentClass = rolloverStore?.getRollover?.learnerAssignmentActions.some(
        (assignment) => assignment.learner === learner._id && assignment.newClassGroups.includes(currentClassGroup.value._id)
      );

      // Check if the learner is assigned to a class with the same subject
      const isAssignedToSameSubject = rolloverStore?.getRollover?.learnerAssignmentActions.some(
        (assignment) => assignment.learner === learner._id && assignment.newClassGroups.some(
          (classGroupId) => {
            const classGroup = schoolClasses.find(group => group._id === classGroupId);
            return classGroup && classGroup.subject === currentClassGroup.value.subject;
          }
        )
      );

      return isAssignedToCurrentClass || !isAssignedToSameSubject;
    });
});

const filteredLearners = computed(() => {
  const query = searchQuery.value.toLowerCase();
  return learnersWithPreviousClasses.value.filter((learner) => {
    const matchesSearchQuery =
      learner.email.toLowerCase().includes(query) ||
      learner.lastName.toLowerCase().includes(query) ||
      learner.firstName.toLowerCase().includes(query) ||
      learner.studentNumber.toLowerCase().includes(query);

    const matchesClassFilter =
      !selectedClassFilter.value ||
      learner.previousClasses.some(
        (classDetails: any) => classDetails.name === selectedClassFilter.value
      );

    return matchesSearchQuery && matchesClassFilter;
  });
});

watch(searchQuery, () => {
  currentPage.value = 1;
});

const filteredAndPaginatedLearners = computed(() => {
  const start = (currentPage.value - 1) * learnersPerPage;
  return filteredLearners.value.slice(start, start + learnersPerPage);
});

const selectedClass = currentClassGroup;

// Filter learners dynamically based on selected class
let filteredLearnersClasses = computed(() => {
  if (!selectedClass) {
    return filteredAndPaginatedLearners.value;
  }

  return filteredAndPaginatedLearners.value.filter((learner) => {
    const alreadyAssignedRollover = rolloverStore?.getRollover?.learnerAssignmentActions.some((assignment) => {
      return (
        assignment.learner === learner._id &&
        assignment.newClassGroups.some((cls) => {
          return cls == selectedClass._id
        })
      );
    });

    // console.log("Already Assigned:", alreadyAssigned);
    return !alreadyAssignedRollover;
  });
});

watch(
  filteredLearnersClasses,
  (newVal, oldVal) => {
    // console.log("Filtered learners updated:", newVal);
  },
  { deep: true }
);

const visiblePages = computed(() => {
  let start = Math.max(currentPage.value - Math.floor(maxVisiblePages / 2), 1);
  let end = Math.min(start + maxVisiblePages - 1, totalPages.value);

  // Adjust the start and end if we are at the end of the page range
  if (end >= totalPages.value) {
    start = Math.max(totalPages.value - maxVisiblePages + 1, 1);
  }

  return Array.from({ length: end - start + 1 }, (_, index) => start + index);
});

const totalPages = computed(() =>
  Math.ceil(filteredLearners.value.length / learnersPerPage)
);

const goToPage = (pageNumber: any) => {
  currentPage.value = pageNumber;
};

const receiveUploadedLearners = (learners: any) => {
  showUploadedLearnersModal.value = true;
  uploadedLearners.value = learners;
};

const clearLearners = () => {
  uploadedLearners.value = [];
  showUploadedLearnersModal.value = false;
};

const submitLearnersForUpload = async () => {
  showUploadedLearnersModal.value = false;
  showLearnersBulkUploadProgressModal.value = true;

  try {
    bulkUploadLoading.value = true;

    await learnerStore.bulkCreateLearners(uploadedLearners.value);

    uploadedLearners.value = [];
    bulkUploadLoading.value = false;
  } catch (error) {
    console.error(error);
  } finally {
    bulkUploadLoading.value = false;
  }
};

const showConfirmation = () => {
  confirmAssignLearnersModal.value = true;
};

let alreadyAssigendLearners = ref<any>([]);

const assignLearners = async () => {
  const currentRollObject = rolloverStore.rollover as Rollover;

  selectedLearners.value.forEach((learnerId) => {
    const learnerExistingAssignmentAction = find(
      currentRollObject.learnerAssignmentActions,
      { learner: learnerId }
    );

    if (learnerExistingAssignmentAction) {
      learnerExistingAssignmentAction.newClassGroups = union(
        learnerExistingAssignmentAction.newClassGroups,
        [currentClassGroup.value._id]
      );
    } else {
      currentRollObject.learnerAssignmentActions.push({
        learner: learnerId,
        newClassGroups: [currentClassGroup.value._id],
      });
    }
  });

  currentRollObject.learnerAssignmentActions = currentRollObject.learnerAssignmentActions.filter(
    (assignment) => {
      if (assignment.newClassGroups.includes(currentClassGroup.value._id)) {
        if (!selectedLearners.value.includes(assignment.learner)) {
          assignment.newClassGroups = assignment.newClassGroups.filter(
            (classGroupId) => classGroupId !== currentClassGroup.value._id
          );
        }
      }
      return assignment.newClassGroups.length > 0;
    }
  );

  alreadyAssigendLearners.value = selectedLearners.value;

  // addLearnerToClass

  await rolloverStore.updateRolloverObject(currentRollObject);

  confirmAssignLearnersModal.value = false;

  // go to /main/add-students
  router.push("/main/add-student");
};

// Method to check if all learners are selected
const areAllSelected = computed(() => {
  const start = (currentPage.value - 1) * learnersPerPage;
  const end = start + learnersPerPage;
  const currentPageLearnersIds = filteredLearners.value
    .slice(start, end)
    .map((learner) => learner._id);
  return currentPageLearnersIds.every((id) =>
    selectedLearners.value.includes(id)
  );
});

// Method to toggle all learners on the current page
const toggleAll = () => {
  const start = (currentPage.value - 1) * learnersPerPage;
  const end = start + learnersPerPage;
  const currentPageLearners = filteredLearners.value.slice(start, end);

  if (areAllSelected.value) {
    // If all are selected, remove them from selectedLearners
    currentPageLearners.forEach((learner) => {
      const index = selectedLearners.value.indexOf(learner._id);
      if (index !== -1) selectedLearners.value.splice(index, 1);
    });
  } else {
    // If not all are selected, add them to selectedLearners
    currentPageLearners.forEach((learner) => {
      if (!selectedLearners.value.includes(learner._id)) {
        selectedLearners.value.push(learner._id);
      }
    });
  }
};

onBeforeMount(async () => {
  await fetchPreviousClasses();
  const classGroupId = route.params.classId;

  currentClassGroup.value =
    schoolStore.currentSchoolStructure?.classGroups.find(
      (classGroup) => classGroup._id === classGroupId
    );

  gradeLevel.value = currentClassGroup.value?.gradeLevel;

  const learners = learnerStore.getLearnersByGrade(currentClassGroup.value?.gradeLevel ?? 0);

  if (learners.length > 0) {
    for (const learner of learners) {
      rolloverStore.addLearnerToLearnerAssignmentActions(learner);
    }

    // Update the rollover object
    // await rolloverStore.updateRolloverObject(rolloverStore.rollover as Rollover);
  }

  const currentRollover = rolloverStore.rollover as Rollover;

  const alreadSelectedLearners = currentRollover.learnerAssignmentActions
    .filter((action) =>
      action.newClassGroups.includes(currentClassGroup.value._id)
    )
    .map((action) => action.learner);

  selectedLearners.value = alreadSelectedLearners;
});

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    // Call the validateEmail action with the node's value
    const emailExists = await learnerStore.validateEmail(node.value as string);
    return !emailExists;
  } catch (error) {
    return true;
  }
};

const sortBy = (key: string) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey.value = key;
    sortOrder.value = 'asc';
  }
};

const sortedLearners = computed(() => {
  if (!sortKey.value) return filteredLearnersClasses.value;

  return [...filteredLearnersClasses.value].sort((a, b) => {
    const result = a[sortKey.value].localeCompare(b[sortKey.value]);
    return sortOrder.value === 'asc' ? result : -result;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg flex flex-row items-center gap-1.5",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
        }, [
          _createVNode(_unref(VideoCameraIcon), {
            class: "-ml-0.5 h-5 w-5",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("global.tutorial")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _createTextVNode("Class: " + _toDisplayString(currentClassGroup.value?.name) + " - ", 1),
              (currentClassGroup.value?.subject === '6572e09f4af560ef2589e5ba')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "M"))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "E"))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, _toDisplayString(selectedLearners.value.length) + " " + _toDisplayString(_ctx.$t("archive_flow.selected")), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "search",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
              placeholder: "Search...",
              class: "rounded-md border-0 bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-[#155EEF] sm:text-sm sm:leading-6 px-4 py-2 w-1/2"
            }, null, 512), [
              [_vModelText, searchQuery.value]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.previous_class_label")) + ": ", 1),
              _withDirectives(_createElementVNode("select", {
                id: "class-filter",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedClassFilter).value = $event)),
                class: "text-[#344054] text-semibold py-2.5 px-4 rounded-lg flex gap-1 border border-[#D0D5DD] w-full"
              }, [
                _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.all_classes_text")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniquePreviousClasses.value, (className) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: className,
                    value: className
                  }, _toDisplayString(className), 9, _hoisted_13))
                }), 128))
              ], 512), [
                [_vModelSelect, selectedClassFilter.value]
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_14, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_15, [
                _createElementVNode("th", _hoisted_16, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    onChange: toggleAll,
                    checked: areAllSelected.value,
                    class: "h-4 w-4 border border-[#0060EE] text-[#0060EE] focus:ring-[#0060EE]"
                  }, null, 40, _hoisted_17)
                ]),
                _createElementVNode("th", {
                  class: "border-y border-y-[#EAECF0] py-3 text-[#475467] font-medium text-xs text-start",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (sortBy('firstName')))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.first_name")) + " ", 1),
                  (sortKey.value === 'firstName' || sortKey.value === null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(sortOrder.value === 'asc' ? '▲' : '▼'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  class: "border-y border-y-[#EAECF0] py-3 text-[#475467] font-medium text-xs text-start",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (sortBy('lastName')))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.last_name")) + " ", 1),
                  (sortKey.value === 'lastName' || sortKey.value === null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(sortOrder.value === 'asc' ? '▲' : '▼'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", {
                  class: "border-y border-y-[#EAECF0] py-3 text-[#475467] font-medium text-xs text-start",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (sortBy('email')))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.email")) + " ", 1),
                  (sortKey.value === 'email' || sortKey.value === null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(sortOrder.value === 'asc' ? '▲' : '▼'), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.previous_class")), 1),
                _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t("archive_flow.learners_table.student_number")), 1),
                _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t("archive_flow.learners_table.password")), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedLearners.value, (learner, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: _normalizeClass([{
              'selected-row': selectedLearners.value.includes(learner._id),
            }, "mb-1"])
                }, [
                  _createElementVNode("td", _hoisted_24, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: learner._id,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedLearners).value = $event)),
                      class: "h-4 w-4 border border-[#0060EE]"
                    }, null, 8, _hoisted_25), [
                      [_vModelCheckbox, selectedLearners.value]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(learner.firstName), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(learner.lastName), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(learner.email), 1),
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("ul", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learner.previousClasses, (classDetails, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: classDetails.id._id
                        }, [
                          _createElementVNode("span", null, [
                            _createTextVNode(_toDisplayString(classDetails.name) + " - " + _toDisplayString(classDetails.id?.subject?.name?.charAt(0)), 1),
                            (index !== learner.previousClasses.length - 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, ","))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_32, _toDisplayString(learner.studentNumber), 1),
                  _hoisted_33
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (pageNumber) => {
              return (_openBlock(), _createElementBlock("button", {
                key: pageNumber,
                onClick: ($event: any) => (goToPage(pageNumber)),
                class: _normalizeClass(["pagination-btn rounded-sm p-2 text-xs font-medium w-6 h-6 leading-none flex justify-center items-center", { 'pagination-active-btn': pageNumber === currentPage.value }])
              }, _toDisplayString(pageNumber), 11, _hoisted_35))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_router_link, {
            to: "/main/add-student",
            class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.cancel")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", {
              class: "formkit-input inline-block w-full rounded-lg bg-[#0060EE] py-2 px-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-base font-semibold leading-normal text-white",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (showConfirmation()))
            }, _toDisplayString(_ctx.$t("archive_flow.complete_assign_learners")), 1)
          ])
        ])
      ]),
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: showGenerateEmailModal.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-10",
            onClose: _cache[10] || (_cache[10] = ($event: any) => (showGenerateEmailModal.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                    "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-2xl bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:p-6" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_unref(DialogTitle), {
                                as: "h3",
                                class: "text-xl font-medium leading-6 text-[#101828]"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Do you have an email address for all of the learners in this class?")
                                ]),
                                _: 1
                              }),
                              _hoisted_43
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("button", {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => {
                    shouldGenerateEmail.value = false;
                  showGenerateEmailModal.value = false;
                  showFileUploadModal.value = true;
                  }),
                              type: "button",
                              class: "w-20 rounded-full bg-white px-4 py-2.5 text-sm font-semibold text-[#155EEF] shadow-sm ring-1 ring-inset ring-[#155EEF] hover:bg-gray-50"
                            }, " Yes "),
                            _createElementVNode("button", {
                              onClick: _cache[9] || (_cache[9] = ($event: any) => {
                    shouldGenerateEmail.value = true;
                  showGenerateEmailModal.value = false;
                  showFileUploadModal.value = true;
                  }),
                              type: "button",
                              class: "w-20 rounded-full bg-[#155EEF] px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-rl-base-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rl-base-bg-[#155EEF]"
                            }, " No ")
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: showFileUploadModal.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-10",
            onClose: _cache[12] || (_cache[12] = ($event: any) => (showFileUploadModal.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_45
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                    "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:p-6" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_unref(DialogTitle), {
                                as: "h3",
                                class: "text-lg font-semibold leading-6 text-gray-900"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Upload new learners to Class " + _toDisplayString(currentClassGroup.value.name), 1)
                                ]),
                                _: 1
                              }),
                              (_unref(schoolStore).currentSchool)
                                ? (_openBlock(), _createBlock(FileUploadWidgetComponent, {
                                    key: 0,
                                    classGroupId: currentClassGroup.value._id,
                                    shouldGenerateEmail: shouldGenerateEmail.value,
                                    schoolData: _unref(schoolStore).currentSchool,
                                    validate: true,
                                    onCloseUploadModal: _cache[11] || (_cache[11] = ($event: any) => (showFileUploadModal.value = false)),
                                    onUploadedLearners: receiveUploadedLearners
                                  }, null, 8, ["classGroupId", "shouldGenerateEmail", "schoolData"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: showUploadedLearnersModal.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-10",
            onClose: _cache[13] || (_cache[13] = ($event: any) => (showUploadedLearnersModal.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                    "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl sm:p-6" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _createVNode(_unref(DialogTitle), {
                                as: "h3",
                                class: "text-lg font-semibold leading-6 text-[#101828]"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Bulk upload new students to [class]")
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(licenseStore).license?.products, (product) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: product.title,
                                      class: "w-full"
                                    }, [
                                      _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("h5", _hoisted_57, _toDisplayString(product.title), 1),
                                        _createElementVNode("h5", null, _toDisplayString(product.seatsUsed) + "/" + _toDisplayString(product.maxSeats), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_58, [
                                        _createElementVNode("div", {
                                          class: "bg-[#155EEF] h-2 rounded-full",
                                          style: _normalizeStyle({ width: licenseProgress.value(product) + '%' })
                                        }, null, 4)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]),
                            _hoisted_59,
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("table", _hoisted_61, [
                                _hoisted_62,
                                _createElementVNode("tbody", _hoisted_63, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedLearners.value, (learner, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      class: "rounded-lg",
                                      key: index
                                    }, [
                                      _createElementVNode("td", _hoisted_64, [
                                        _createVNode(_unref(UserIcon), { class: "w-5 h-5 text-gray-500" })
                                      ]),
                                      _createElementVNode("td", _hoisted_65, [
                                        _createVNode(_component_FormKit, {
                                          type: "text",
                                          name: "learnerEmail",
                                          modelValue: learner.email,
                                          "onUpdate:modelValue": ($event: any) => ((learner.email) = $event),
                                          placeholder: "Learner Email",
                                          classes: {
                                outer: '',
                                wrapper: 'w-11/12',
                                input:
                                  'w-full text-sm border border-gray-500 py-2 h-10 rounded-lg px-4 focus:ring-1 focus:ring-rl-base-blue-500 focus:outline-none focus:ring-opacity-50',
                              },
                                          validation: "required|(500)email_exists",
                                          "validation-rules": { email_exists: email_exists },
                                          "validation-visibility": "live",
                                          "validation-messages": {
                                email_exists:
                                  'Sorry, that email is taken. Try a different one.',
                              }
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"])
                                      ]),
                                      _createElementVNode("td", _hoisted_66, _toDisplayString(learner.firstName), 1),
                                      _createElementVNode("td", _hoisted_67, _toDisplayString(learner.lastName), 1),
                                      _createElementVNode("td", _hoisted_68, _toDisplayString(learner.studentNumber), 1),
                                      _createElementVNode("td", _hoisted_69, _toDisplayString(learner.password), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("button", {
                              onClick: clearLearners,
                              type: "button",
                              class: "inline-flex items-center gap-x-2 rounded-full bg-white px-4 py-2.5 text-sm font-semibold text-rl-base-pink-500 shadow-sm ring-1 ring-inset ring-rl-base-pink-500 hover:bg-gray-50"
                            }, [
                              _createVNode(_unref(TrashIcon), {
                                class: "-ml-0.5 h-5 w-5",
                                "aria-hidden": "true"
                              }),
                              _createTextVNode(" Remove ")
                            ]),
                            _createElementVNode("button", {
                              onClick: submitLearnersForUpload,
                              type: "button",
                              class: "rounded-full bg-rl-base-blue-500 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-rl-base-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rl-base-bg-rl-base-blue-500"
                            }, " Submit ")
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: showLearnersBulkUploadProgressModal.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-40",
            onClose: _cache[16] || (_cache[16] = ($event: any) => (showLearnersBulkUploadProgressModal.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_71
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                    "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (showLearnersBulkUploadProgressModal.value = false)),
                              class: "absolute top-4 right-4"
                            }, [
                              _createVNode(_component_XMarkIcon, { class: "w-6 h-6 text-gray-500" })
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, [
                                (bulkUploadLoading.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_76, [
                                      _createVNode(_component_spinner_loader, { color: 'text-rl-base-blue-500' })
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_77
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              _createVNode(_unref(DialogTitle), {
                                as: "h3",
                                class: "text-2xl font-semibold leading-6 text-gray-600"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(bulkUploadLoading.value
                          ? "Sending learners for upload"
                          : "Upload complete"), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _hoisted_79
                          ]),
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "bg-[#8777FF] rounded-full px-8 py-2 text-base shadow-lg text-white mx-2 flex flex-row justify-center items-center flex-wrap",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (showLearnersBulkUploadProgressModal.value = false))
                            }, " Assign existing students "),
                            _createVNode(_component_router_link, { to: "/main/add-student" }, {
                              default: _withCtx(() => [
                                _hoisted_81
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: confirmAssignLearnersModal.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-40",
            onClose: _cache[19] || (_cache[19] = ($event: any) => (confirmAssignLearnersModal.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_82
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                    "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _hoisted_85,
                            _createElementVNode("div", _hoisted_86, [
                              _createVNode(_unref(DialogTitle), {
                                as: "h3",
                                class: "text-2xl font-semibold leading-6 text-[#101828]"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.modals.confirm_selection")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_87, [
                              _createElementVNode("p", _hoisted_88, _toDisplayString(_ctx.$t("archive_flow.modals.youve_selected")) + ":", 1),
                              _createElementVNode("p", _hoisted_89, _toDisplayString(selectedLearners.value.length) + " " + _toDisplayString(_ctx.$t("archive_flow.modals.students_move")) + " " + _toDisplayString(currentClassGroup.value?.name), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("button", {
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (confirmAssignLearnersModal.value = false)),
                              type: "button",
                              class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full"
                            }, _toDisplayString(_ctx.$t("archive_flow.modals.edit")), 1),
                            _createElementVNode("button", {
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (assignLearners())),
                              type: "button",
                              class: "text-white border border-[#155EEF] bg-[#155EEF] text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full"
                            }, _toDisplayString(_ctx.$t("archive_flow.modals.correct")), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createVNode(TutorialModalComponent, {
      show: showModal.value,
      "onUpdate:show": _cache[20] || (_cache[20] = ($event: any) => ((showModal).value = $event))
    }, {
      headerSlot: _withCtx(() => [
        _createTextVNode(" Tutorial ")
      ]),
      descriptionSlot: _withCtx(() => [
        _createTextVNode(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus commodi, suscipit, unde deleniti distinctio qui culpa vero repudiandae eum provident laudantium officia laboriosam harum iste fugit nobis minus, consectetur dolorem. ")
      ]),
      strapiContent: _withCtx(() => [
        _createTextVNode(" Strapi content to go here... ")
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})